module.exports = __webpack_public_path__ + "img/strawberry03.2b37b396.jpg";